export const ViewDashboardOverviewFragment = gql`
  fragment ViewDashboardOverviewFragment on ViewDashboard {
    id
    description
    icon
    isPublished
    name
    summary
    uuid
    views {
      id
    }
  }
`

export const ViewDashboardFragment = gql`
  fragment ViewDashboardFragment on ViewDashboard {
    id
    description
    icon
    isPublished
    name
    summary
    uuid
    organization {
      id
      slug
    }
    recordType {
      id
    }
    views {
      ...ViewFragment
    }
  }
`
